'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

class SchemaMismatchError extends Error {
  constructor(channel, schema, newSchema) {
    super(`schema registration for [${channel}] must match already registered schema.`);
    this.channel = channel;
    this.schema = schema;
    this.newSchema = newSchema;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, SchemaMismatchError);
    }
    this.name = "SchemaMismatchError";
  }
}

exports.SchemaMismatchError = SchemaMismatchError;
